export default "__VITE_ASSET__6d784489__"